import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Auth from "./Auth";
import Notes from "./Notes";
import Contact from "./Contact";
import Common from "./Common";
import Chat from "./Chat";
import Spares from "./Spares";
import ProductTracking from "./ProductTracking";
import ClientTicket from "./ClientTicket";
import ClientProject from "./ClientProject";
import Tasks from "./Tasks";
import TicketDetailsV2 from "./TicketDetailsV2";
import LogisticsProductTracking from "./LogisticsProductTracking";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    notes: Notes,
    contact: Contact,
    common: Common,
    chat: Chat,
    spares: Spares,
    productTracking: ProductTracking,
    clientTicket: ClientTicket,
    clientProject: ClientProject,
    tasks: Tasks,
    ticketDetailsV2: TicketDetailsV2,
    logisticsProductTracking: LogisticsProductTracking,
  });

export default createRootReducer;
